<template>
  <layout-card-wrap
    v-loading="loading"
    hasSlot>
    <template slot="title">概况</template>
    <summary-list
      :list="list1"
      :span="6" />
    <!-- <summary-list
      :list="list2"
      :span="8" /> -->
  </layout-card-wrap>
</template>

<script>
import SummaryList from './summary.vue'
import moment from 'moment'
export default {
  name: 'ScmData',
  components: { SummaryList },
  data() {
    return {
      loading: true,
      list1: [
        {
          label: '批次数(个)',
          value: '0'
        },
        {
          label: '产品种类(种)',
          value: '0'
        },
        {
          label: '产品数量(件)',
          value: '0'
        },
        {
          label: '供应链企业(家)',
          value: '0'
        }
      ]
      // list2: [
      //   {
      //     label: '快检企业(家)',
      //     value: '0'
      //   },
      //   {
      //     label: '产品种类(种)',
      //     value: '0'
      //   }
      // ]
    }
  },
  mounted() {
    this.getbasicdatastat()
  },
  methods: {
    getbasicdatastat() {
      this.loading = true
      this.$store.dispatch('account/getscmstat', {
        payload: {
          beginMonth: moment().format('YYYYMM'),
          endMonth: moment().format('YYYYMM')
        },
        success: (res) => {
          this.loading = false
          const data = res.data
          this.$set(this, 'list1', [
            {
              label: '批次数(个)',
              value: data.totalBatchCount
            },
            {
              label: '产品种类(种)',
              value: data.totalProductCount
            },
            {
              label: '产品数量(件)',
              value: data.totalGoodsCount
            },
            {
              label: '供应链企业(家)',
              value: data.totalVendorCount
            }
          ])
          // this.$set(this, 'list2', [
          //   {
          //     label: '快检企业(家)',
          //     value: data.totalVendorCount
          //   },
          //   {
          //     label: '产品种类(种)',
          //     value: data.totalProductCount
          //   }
          // ])
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>
